import ComparisonCards from "./ComparisonCards";

export default ComparisonCards;
export type { ComparisonCardProps, ComparisonCardsAdapterProps } from "./ComparisonCards.d";
